import { connect } from 'react-redux'
import React, { PureComponent } from 'react'
import Splash, { ISkin } from '../../views/splash/Splash'
import appActions from '../../redux/actions/appActions'
import withTransition from '../../hoc/Transition'
import withResizer from '../../hoc/Resizer'
import viewSelector from '../../redux/selectors/splash/viewSelector'
import { bindActionCreators, AnyAction, Dispatch } from 'redux'
import { IGameSettings } from '../../helpers/data/gameSettings'
import { IStore } from '../../redux/reducers/index'

interface ISplashState {
	isComplete: boolean
}

interface ISplashProps {
	splashComplete: () => void
	gameSettings: (settings: any) => void
	settings: IGameSettings
	skin: ISkin
	canParticipate: boolean
	sessionType: string | number
}

class SplashConnector extends PureComponent<ISplashProps, ISplashState> {
	private timeoutId = 0

	state = {
		isComplete: false,
	}

	componentDidMount() {
		window.setTimeout(() => {
			this.onComplete()
		}, 6000)
	}

	onComplete = () => {
		if (!this.state.isComplete) {
			this.setState({
				isComplete: true,
			})
			this.props.splashComplete()
		}
	}

	onSettingsSubmit = (settings: any) => {
		this.props.gameSettings(settings)
	}

	render() {
		return (
			<Splash
				onComplete={this.onComplete}
				onSettingsSubmit={this.onSettingsSubmit}
				skin={this.props.skin}
				settings={this.props.settings}
				canParticipate={this.props.canParticipate}
				sessionType={this.props.sessionType}
			/>
		)
	}

	componentWillUnmount() {
		window.clearTimeout(this.timeoutId)
	}
}

const mapStateToProps = (state: IStore) => {
	return viewSelector(state)
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
	return bindActionCreators(
		{
			splashComplete: appActions.splashComplete,
			gameSettings: appActions.gameSettings,
		},
		dispatch
	)
}

export default withTransition(withResizer(connect(mapStateToProps, mapDispatchToProps)(SplashConnector), 1024, 768))
